import { Content } from 'core/layouts';
import { defaultTemplate } from 'core/hoc';
import { observer } from 'mobx-react';
import React from 'react';
import { PropTypes } from 'mobx-react';
import { BaasicButton } from 'core/components';

function ApplicationTypeValidationTemplate({woundOrderAddWoundDressingViewStore}){
    return(
        <Content>
            <div className="modal__eligibility__header">
                <h3 className="modal__eligibility__header--title">Check Application Types</h3>
                <h3 className="modal__eligibility__header--subtitle">There are multiple Fillers/Primary Dressings/Secondary Dressings/Tertiary Dressings/Tapes. Please chose which dressing you’d like to cover. Pick one for each.</h3>
            </div>
            <div className="modal__eligibility__body"> 
                {Object.entries(woundOrderAddWoundDressingViewStore.dressingCombinationResult).map(([guid, objects]) => (
                    <div className='card--modal' key={guid}>
                        <div className='card--modal__title'>
                            {objects[0].wound.location} | Group - {objects[0].applicationType.name || 'No Description Available'}
                        </div>
                        <div className='card--modal__item'>
                            <div className="card--modal__item--list">
                                {objects.map((object, index) => (
                                    <BaasicButton 
                                        key={index}
                                        title= {object.product.description || "Unnamed Product"}
                                        onClick={() => woundOrderAddWoundDressingViewStore.onSelectProduct(guid, object.id)}
                                        className={"btn--toggle btn--toggle--eligibility btn--base " + (woundOrderAddWoundDressingViewStore.selectedWoundDressings.some(option => option.groupId === guid && option.woundDressingId === object.id)? 'active' : '')
                                        }                                        
                                        label={object.product.description || "Unnamed Product"}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="modal__eligibility__footer">
                <BaasicButton
                    className='btn btn--med btn--secondary'
                    label="Cancel"
                    onClick={() => woundOrderAddWoundDressingViewStore.closeApplicationTypeValidationModal()}
                />
                <BaasicButton 
                    className='btn btn--med btn--secondary'
                    label="Confirm Choices"
                    onClick={() => woundOrderAddWoundDressingViewStore.submitDressingCombinations()}
                />     
            </div>
        </Content>
    );
}

ApplicationTypeValidationTemplate.propTypes = {
    woundOrderAddWoundDressingViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ApplicationTypeValidationTemplate);